<template>
  <v-dialog
    v-model="dialogIsShown"
    max-width="500px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        text
        x-small
      >
        Besoin d'aide ?
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="white--text secondary pa-4">
        Besoin d'aide ?
      </v-card-title>

      <v-card-text class="pa-4">
        <p>Pour toutes questions concernant votre postulation et le traitement de votre postulation, veuillez contacter <a href="mailto:infoemploi@condorcet.be">infoemploi@condorcet.be</a></p>
        <p>Si vous rencontrez un problème technique, veuillez contacter : <a href="mailto:support.postulations@condorcet.be">support.postulations@condorcet.be</a></p>
        
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center">
        <v-btn
          text
          @click="dialogIsShown = false"
        >
          Fermer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'HelpDialog',

  props: {
    value: Boolean,
  },

  computed: {
    dialogIsShown: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
